import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54c497b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Exportar dashboard", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-[15px] h-[15px] bg-primary10 rounded" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-[15px] h-[15px] bg-tertiary rounded" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-[15px] h-[15px] bg-feedBackSuccess rounded" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-[15px] h-[15px] bg-alert rounded" }, null, -1))
const _hoisted_6 = { class: "font-bold" }
const _hoisted_7 = { class: "font-bold" }

import { storeToRefs } from 'pinia'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import GhostButton from '@/components/designSystem/Buttons/GhostButton/index.vue'
import { ref } from 'vue'
import Network from '@/Network'
import { useToast } from 'vue-toastification'
import { useErrorToast } from '@/composables/useErrorToast'
import { mdiCalendar } from '@mdi/js'
import { DatePicker } from 'v-calendar'
import * as pdfMake from 'pdfmake/build/pdfmake'
import * as pdfFonts from 'pdfmake/build/vfs_fonts'
import { TDocumentDefinitions } from 'pdfmake/interfaces'
import { getDocDefinition, getWeeksBetweenDates } from './helpers'
import {
  DashboardType
  //  ListFiltersRequest
} from '@/Network/Types/Requests/StationRequests'
import { ListStationsResponse } from '@/Network/Types/Responses/StationResponses'
import { useStationStore } from '@/pinia-store/useStationStore'
import { computed } from 'vue'
import { useHealthUnitStore } from '@/pinia-store/useHealthUnitStore'
import { useScheduleStore } from '@/pinia-store/useScheduleStore'
import { watch } from 'vue'
import { formatDateToString } from '@/utils/date'
import Card from './components/card.vue'
import {
  getDay,
  addDays,
  // startOfWeek,
  endOfWeek
} from 'date-fns'
/* ******** Modal Props and Actions Default *********** */

export default /*#__PURE__*/_defineComponent({
  __name: 'export.stations.modal',
  setup(__props) {

const modalName = EModals.EXPORT_DASHBOARD_STATIONS
const { modals } = storeToRefs(useModalStore())
const modalStore = useModalStore()
const handleToggleModal = () => {
  modalStore.toggleModal(modalName)
}
/* **************************************************** */
const toast = useToast()
const { notifyError } = useErrorToast()
const isLoading = ref<boolean>(false)

const { listStationsQuery } = storeToRefs(useStationStore())
const healthUnitStore = useHealthUnitStore()
const scheduleStore = useScheduleStore()
const { healthUnitsMap } = storeToRefs(healthUnitStore)
const { schedulesMap } = storeToRefs(scheduleStore)
const startDateError = ref<string>('')
const startDate = ref<Date>(new Date())

watch(
  () => startDate.value,
  () => {
    if (!startDate.value) {
      startDateError.value = 'Data inicial é obrigatória'
      return
    }
    startDateError.value = ''
  }
)
const endDateError = ref<string>('')
const endDate = ref<Date>(new Date())
watch(
  () => endDate.value,
  () => {
    if (!endDate.value) {
      endDateError.value = 'Data final é obrigatória'
      return
    }
    endDateError.value = ''
  }
)

const openedStation = ref<boolean>(true)
const stationFixo = ref<boolean>(true)
const stationCobertura = ref<boolean>(true)
const stationExtra = ref<boolean>(true)
const doctorPending = ref<boolean>(true)
const confirmed = ref<boolean>(true)
const notConfirmed = ref<boolean>(true)
const hideLabels = ref<boolean>(false)

const schedulesFilter = computed(() => {
  if (!listStationsQuery) return
  return listStationsQuery.value.schedules?.map((u) => ({
    id: u,
    text: schedulesMap.value.get(+u)
  }))
})

const unitsFilter = computed(() => {
  if (!listStationsQuery) return
  return listStationsQuery.value.healthUnits?.map((u) => ({
    id: u,
    text: healthUnitsMap.value.get(+u)
  }))
})

const getStations = async (): Promise<
  { weekStartDate: string; responseData: ListStationsResponse }[]
> => {
  let effectiveStartDate = new Date(startDate.value)
  let effectiveEndDate = new Date(endDate.value)

  if (getDay(effectiveStartDate) === 0) {
    effectiveStartDate = addDays(effectiveStartDate, 1)

    if (effectiveStartDate > effectiveEndDate) {
      effectiveEndDate = endOfWeek(effectiveStartDate, { weekStartsOn: 1 })
    }
  }

  const weeks = getWeeksBetweenDates(effectiveStartDate, effectiveEndDate)

  if (weeks.length === 0) {
    toast.warning('Nenhum período semanal válido encontrado para as datas selecionadas.')
    return []
  }

  const requests = weeks.map((week) => ({
    ...listStationsQuery.value,
    startDate: week.startDate,
    endDate: week.endDate,
    type: DashboardType.WEEK,
    doctorPending: getDoctorPending(),
    openedStation: getOpenedStation(),
    stationType: getStationType()
  }))

  const responses = await Promise.all(
    weeks.map(async (week, i) => {
      const data = await Network.station.list(requests[i])
      return {
        weekStartDate: week.weekStartDate,
        responseData: data
      }
    })
  )

  return responses.filter((item) => item.responseData && item.responseData.data)
}

const getStationType = (): string[] | undefined => {
  const stationsTypes: string[] = []
  if (stationFixo.value) stationsTypes.push('FIXO')
  if (stationCobertura.value) stationsTypes.push('COBERTURA')
  if (stationExtra.value) stationsTypes.push('EXTRA')

  return stationsTypes.length ? stationsTypes : undefined
}

const getDoctorPending = (): string | undefined => {
  // No backend, doctorPending filtra por confirmação do plantão:
  // true → só não confirmados; false → só confirmados; omitido → todos.
  // O checkbox "Médico Pendente" é apenas legenda visual e não entra na request.
  if (confirmed.value === notConfirmed.value) return undefined
  return String(notConfirmed.value)
}

const removePendingDoctorCards = (
  weeks: { weekStartDate: string; responseData: ListStationsResponse }[]
) => {
  // O backend não tem filtro por convite pendente (doctorPending na response),
  // então com o checkbox "Médico Pendente" desmarcado os cards são removidos aqui.
  if (doctorPending.value) return weeks
  weeks.forEach(({ responseData }) =>
    responseData.data?.forEach((company) =>
      company.healthUnities?.forEach((unit) =>
        unit.schedules?.forEach((schedule) =>
          schedule.shifts?.forEach((shift) =>
            shift.hours?.forEach((hour) =>
              hour.positions?.forEach((position) => {
                position.stations = position.stations?.map(
                  (day) => day?.filter((card) => !card?.doctorPending) ?? day
                )
              })
            )
          )
        )
      )
    )
  )
  return weeks
}

const getOpenedStation = (): string | undefined => {
  const hasOtherStationType = stationFixo.value || stationCobertura.value || stationExtra.value
  if (openedStation.value && hasOtherStationType) return undefined
  return String(openedStation.value)
}

const handleExport = async () => {
  try {
    isLoading.value = true

    // Busca os dados (já com a correção dos filtros de Unidades e Escalas que fizemos antes)
    const data = removePendingDoctorCards(await getStations())

    // Validação se há dados retornados
    if (!data.length || data.every((item) => !item.responseData?.data?.length)) {
      toast.warning('Nenhum dado encontrado para o período e filtros selecionados.')
      return
    }

    // Gera a definição do PDF passando os dados E o booleano para ocultar legendas
    const docDefinition: TDocumentDefinitions = getDocDefinition(data, hideLabels.value)

    // Cria o binário do PDF
    const pdf = pdfMake.createPdf(
      docDefinition,
      undefined,
      undefined,
      (pdfFonts as Record<string, unknown>).vfs as Record<string, string>
    )

    // Gera o Blob e força o download
    pdf.getBlob((blob) => {
      const file = new Blob([blob], { type: 'application/octet-stream' })
      const a = document.createElement('a')
      a.href = URL.createObjectURL(file)
      a.target = '_blank'
      a.download = `Plantoes de ${formatDateToString(startDate.value)} ate ${formatDateToString(
        endDate.value
      )}.pdf`
      a.click()
    })

    toast.success('PDF exportado com sucesso')
    handleToggleModal()
  } catch (error) {
    console.error(error)
    // Antes: "Erro ao exportar PDF" estático — o load dos plantões (service
    // normalizado) pode falhar com mensagem específica.
    notifyError(error, 'Não foi possível exportar o PDF')
  } finally {
    isLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createBlock(ModalVue, {
    onClose: handleToggleModal,
    modalActive: _unref(modals)[_unref(modalName)],
    hasFooterBorder: true,
    isFilterModal: ""
  }, {
    header: _withCtx(() => [
      _createVNode(_component_v_row, { dense: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "text-left text-xl"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_v_row, {
        dense: "",
        class: "pt-5"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(GhostButton, {
                onClick: handleToggleModal,
                width: "100%",
                text: "Cancelar"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(FilledButton, {
                loading: isLoading.value,
                onClick: handleExport,
                text: "Exportar",
                height: "52px",
                width: "100%"
              }, null, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_row, { dense: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DatePicker), {
                modelValue: startDate.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startDate).value = $event)),
                class: "w-full",
                locale: "pt-BR",
                masks: { input: `DD/MM/YYYY` }
              }, {
                default: _withCtx(({ inputValue, inputEvents }) => [
                  _createVNode(_component_v_text_field, _mergeProps({
                    placeholder: "Dia Inicial",
                    "prepend-inner-icon": _unref(mdiCalendar),
                    value: inputValue
                  }, _toHandlers(inputEvents), {
                    density: "compact",
                    variant: "outlined",
                    class: "w-full",
                    color: "primary20",
                    error: !!startDateError.value,
                    "error-messages": startDateError.value
                  }), null, 16, ["prepend-inner-icon", "value", "error", "error-messages"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DatePicker), {
                modelValue: endDate.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((endDate).value = $event)),
                locale: "pt-BR",
                masks: { input: `DD/MM/YYYY` }
              }, {
                default: _withCtx(({ inputValue, inputEvents }) => [
                  _createVNode(_component_v_text_field, _mergeProps({
                    placeholder: "Dia Final",
                    "prepend-inner-icon": _unref(mdiCalendar),
                    value: inputValue
                  }, _toHandlers(inputEvents), {
                    density: "compact",
                    variant: "outlined",
                    class: "w-full",
                    color: "primary20",
                    error: !!endDateError.value,
                    "error-messages": endDateError.value
                  }), null, 16, ["prepend-inner-icon", "value", "error", "error-messages"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { dense: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            class: "font-bold text-left text-md",
            cols: "12"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Incluir no PDF:")
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { dense: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6",
                class: "flex items-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    modelValue: stationFixo.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((stationFixo).value = $event)),
                    density: "compact",
                    label: "Plantão Fixo",
                    color: "primary",
                    "hide-details": ""
                  }, null, 8, ["modelValue"]),
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6",
                class: "flex items-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    modelValue: stationCobertura.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((stationCobertura).value = $event)),
                    density: "compact",
                    label: "Plantão Cobertura",
                    color: "primary",
                    "hide-details": ""
                  }, null, 8, ["modelValue"]),
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6",
                class: "flex items-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    modelValue: stationExtra.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((stationExtra).value = $event)),
                    density: "compact",
                    label: "Plantão Extra",
                    color: "primary",
                    "hide-details": ""
                  }, null, 8, ["modelValue"]),
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6",
                class: "flex items-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    modelValue: openedStation.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((openedStation).value = $event)),
                    density: "compact",
                    label: "Vaga Aberta",
                    color: "primary",
                    "hide-details": ""
                  }, null, 8, ["modelValue"]),
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6",
                class: "flex items-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    modelValue: confirmed.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((confirmed).value = $event)),
                    density: "compact",
                    label: "Confirmado",
                    color: "primary",
                    "hide-details": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6",
                class: "flex items-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    modelValue: notConfirmed.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((notConfirmed).value = $event)),
                    density: "compact",
                    label: "Não confirmado",
                    color: "primary",
                    "hide-details": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6",
                class: "flex items-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    modelValue: doctorPending.value,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((doctorPending).value = $event)),
                    density: "compact",
                    label: "Médico Pendente",
                    color: "primary",
                    "hide-details": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6",
                class: "flex items-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    modelValue: hideLabels.value,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((hideLabels).value = $event)),
                    density: "compact",
                    label: "Ocultar legendas",
                    color: "primary",
                    "hide-details": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        dense: "",
        class: "md:py-5"
      }, {
        default: _withCtx(() => [
          (openedStation.value)
            ? (_openBlock(), _createBlock(Card, {
                key: 0,
                type: "ABERTO",
                confirmed: confirmed.value,
                "not-confirmed": notConfirmed.value,
                "doctor-pending": doctorPending.value,
                "hide-labels": hideLabels.value
              }, null, 8, ["confirmed", "not-confirmed", "doctor-pending", "hide-labels"]))
            : _createCommentVNode("", true),
          (stationFixo.value)
            ? (_openBlock(), _createBlock(Card, {
                key: 1,
                confirmed: confirmed.value,
                "not-confirmed": notConfirmed.value,
                "doctor-pending": doctorPending.value,
                type: "FIXO",
                "hide-labels": hideLabels.value
              }, null, 8, ["confirmed", "not-confirmed", "doctor-pending", "hide-labels"]))
            : _createCommentVNode("", true),
          (stationCobertura.value)
            ? (_openBlock(), _createBlock(Card, {
                key: 2,
                confirmed: confirmed.value,
                "not-confirmed": notConfirmed.value,
                "doctor-pending": doctorPending.value,
                type: "COBERTURA",
                "hide-labels": hideLabels.value
              }, null, 8, ["confirmed", "not-confirmed", "doctor-pending", "hide-labels"]))
            : _createCommentVNode("", true),
          (stationExtra.value)
            ? (_openBlock(), _createBlock(Card, {
                key: 3,
                confirmed: confirmed.value,
                "not-confirmed": notConfirmed.value,
                "doctor-pending": doctorPending.value,
                type: "EXTRA",
                "hide-labels": hideLabels.value
              }, null, 8, ["confirmed", "not-confirmed", "doctor-pending", "hide-labels"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "text-left" }, {
        default: _withCtx(() => [
          (unitsFilter.value?.length)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                class: "text-sm text-primary",
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Unidades: "),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(unitsFilter.value?.map((s) => s.text).join(', ')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (schedulesFilter.value?.length)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                class: "text-sm text-primary",
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Escalas: "),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(schedulesFilter.value?.map((s) => s.text).join(', ')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})